import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { UploaddataService } from 'src/app/services/uploaddata.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-bulk-suspension-reactivation',
  templateUrl: './bulk-suspension-reactivation.component.html',
  styleUrls: ['./bulk-suspension-reactivation.component.scss']
})
export class BulkSuspensionReactivationComponent implements OnInit {
  form: FormGroup
  data = []
  dataSource: any = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "CustomerName",
    "CustomerNumber",
    "ReferenceNumber",
    "Action"
  ];
  data1 = []
  dataSource1: any = new MatTableDataSource(this.data1);
  displayedColumns1: string[] = [
    "CustomerName",
    "CustomerNumber",
    "ReferenceNumber",
    "ApplicationStatus",
    "Action"
  ];
  showdetailtable = false
  showrevoketable = false;
  customerList: any;
  eftDocumentId: number;
  constructor(
    private formBuilder: FormBuilder,
    private lookupDataService: LookupDataServiceService,
    private applicationdataservice: ApplicationDataService,
    private navigation: NavigationService,
    private uploaddataservice: UploaddataService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      searchQuery: [],
      isRevoked: [false],
    })
    this.getdata()
  }

  getdata() {
    this.lookupDataService.getSuspendCustomerList().subscribe((result) => {
      this.customerList = result
    })
  }

  search() {
    if (this.form.valid) {
      debugger
      const value = this.form.value.searchQuery;
      const foundCustomer = this.customerList.filter(item => item.customerReferenceNumber === value);

      if (foundCustomer.length > 0) {

        foundCustomer.forEach(item => {
          this.uploaddataservice
            .getAllApplicationDocuments(item.applicationId)
            .subscribe((docs) => {

              const eftDocument = docs.find(
                x => x.documentTypeString === 'EFT Payment Proof'
              );

              item.eftDocumentId = eftDocument?.id;
            });
        });
      }

      this.showdetailtable = true;
      if (foundCustomer.length > 0) {
        const isRevoked = this.data1.filter(item => item.customerReferenceNumber === foundCustomer.customerReferenceNumber);
        this.data = [...foundCustomer, ...isRevoked];
        this.dataSource = new MatTableDataSource(this.data);
      } else {
        this.toastr.error("Search with valid Customer Reference Number")
        this.data = [];
        this.dataSource = new MatTableDataSource(this.data);
      }
    }
  }

  clickaction(dataField: any) {
    debugger
    if (dataField.isRevoked === false) {
      dataField.isRevoked = true;
      this.data1 = [...this.data1, dataField];
    }
    else if (dataField.isRevoked === true) {
      dataField.isRevoked = false;
      this.data1 = this.data1.filter(item => item.referenceNumber !== dataField.referenceNumber);
    }
    this.dataSource1 = new MatTableDataSource(this.data1);
    this.showrevoketable = this.data1.length > 0;
    console.log(this.form.value);
  }
  Revoke() {
    this.applicationdataservice.bulkRevokeSPCenter(this.data1).subscribe((result) => {
      if (result == true)
        Swal.fire('Success!!', 'Revoked successfully!', 'success')
      else
        this.toastr.error("Applications cannot be revoked")
      this.Refresh()
    })
  }

  clearFilter() {
    // this.data1=[];
    this.dataSource = new MatTableDataSource(this.data)
    this.showdetailtable = false;
    this.form.reset()

  }
  gotoaddsuspension() {
    this.navigation.gotoaddsuspension();
  }
  Refresh() {
    this.data1 = [];
    this.data = [];
    this.dataSource = new MatTableDataSource(this.data)
    this.dataSource1 = new MatTableDataSource(this.data1)
    this.showrevoketable = false;
    this.showdetailtable = false;
    this.form.reset()
    this.getdata()
  }


  download(eftDocumentId) {
    this.uploaddataservice.downloadFile(eftDocumentId).subscribe((data) => {
      if (data != null) {
        const link = document.createElement("a");
        link.href = data.baseUrl + data.byteImage;
        link.download = `${data.filename}`; //.${data.fileExtention}`;
        link.click();
      }
    })

  }

}
